import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=5d3ecf71&scoped=true&"
import script from "./Appeal.vue?vue&type=script&lang=js&"
export * from "./Appeal.vue?vue&type=script&lang=js&"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=5d3ecf71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ecf71",
  null
  
)

export default component.exports